function Icon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" fill="none" viewBox="0 0 64 64">
      <path
        fill="#0044F0"
        d="M31.991 40.466c-11.501 0-21.325 1.813-21.325 9.066 0 7.256 9.763 9.134 21.325 9.134 11.502 0 21.326-1.811 21.326-9.067s-9.76-9.133-21.326-9.133"
      ></path>
      <path
        fill="#0044F0"
        d="M31.99 33.557c7.836 0 14.113-6.28 14.113-14.112A14.06 14.06 0 0 0 31.99 5.333a14.063 14.063 0 0 0-14.112 14.112c0 7.831 6.28 14.112 14.112 14.112"
        opacity="0.4"
      ></path>
    </svg>
  );
}

export default Icon;
